import {Unavailability, Shift, DeploymentSpecification, TemplateSpecification, DeploymentProposalSpecification} from '@cquential/api';
import Dates from '@cquential/date-utils';

export default class AvailabilityUtil {
    static readonly START_OF_DAY_TIME: string = '00:00:00';
    static readonly END_OF_DAY_TIME: string = '23:59:59';

    public static hasShiftConflict(unavailabilities: Unavailability[], date: Date, shift: Shift): boolean {
        return shift.template!.specifications?.some((specification: TemplateSpecification): boolean => {
            const specificationBeginDate: Date = Dates.Time.setTimeFromTemplateTimeString(date, specification.begin);
            const specificationEndDate: Date = Dates.Time.setTimeFromTemplateTimeString(date, specification.end);

            return this.hasConflict(unavailabilities, specificationBeginDate, specificationEndDate);
        }) ?? false;
    }

    public static hasDeploymentConflict(unavailabilities: Unavailability[], specifications: DeploymentSpecification[] | DeploymentProposalSpecification[]): boolean {
        return specifications.some((specification: DeploymentSpecification | DeploymentProposalSpecification): boolean => this.hasConflict(unavailabilities, specification.begin, specification.end));
    }

    private static hasConflict(unavailabilities: Unavailability[], specificationStartTime: Date, specificationEndTime: Date): boolean {
        return unavailabilities.some((unavailability: Unavailability): boolean => unavailability.startDateTime < specificationEndTime && unavailability.endDateTime > specificationStartTime);
    }
}
